export default __webpack_public_path__ + "static/media/pix.2c7f77f1.svg";